<script lang="ts" setup>
import { computed } from "vue";

// Properties
const props = defineProps({
    modelValue: {
        type: [String, Boolean, Number],
        default: "",
    },
    type: {
        type: String,
        default: "text",
    },
    errorMsg: {
        type: String,
        default: "",
    },
});

// Data
const emit = defineEmits(["update:modelValue", "change", "blur"]);

const model = computed({
    get() {
        return props.modelValue;
    },
    set(value) {
        return emit("update:modelValue", value);
    },
});

// Functions
function onChange(event: any) {
    emit("change", event.target.value);
}

function onBlur(event: any) {
    emit("blur", event.target.value);
}
</script>

<template>
    <textarea
        v-model="model"
        v-tooltip="{
            content: errorMsg,
            shown: errorMsg ? true : false,
            triggers: [],
        }"
        :type="type"
        class="border px-3 py-1 shadow-none drop-shadow-none focus:border-gray-400 focus:outline-none"
        :class="!errorMsg ? 'border-gray-300 bg-gray-50' : 'border-red-700 bg-red-50'"
        @change="onChange"
        @blur="onBlur"
    ></textarea>
</template>
